import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqPartCkuStore', Object.keys(getters)),
	...mapState('pqPartCkuStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqPartCkuStore', Object.keys(actions)),
	...mapMutations('pqPartCkuStore', Object.keys(mutations))
};
